import { cn } from "@/lib/utils";
import { memberStyle, type Member } from "@/lib/meta";

export function MemberAvatar({
  member,
  size = "md",
  className,
}: {
  member: Pick<Member, "initials" | "color" | "name">;
  size?: "sm" | "md" | "lg";
  className?: string;
}) {
  const sizes = {
    sm: "size-6 text-[11px]",
    md: "size-8 text-sm",
    lg: "size-10 text-base",
  };
  return (
    <span
      title={member.name}
      className={cn(
        "inline-flex items-center justify-center rounded-full font-semibold select-none",
        sizes[size],
        memberStyle(member.color).avatar,
        className,
      )}
    >
      {member.initials}
    </span>
  );
}

/** A small colored dot indicating who an item belongs to (or "both"). */
export function WhoDot({ color, both }: { color?: string; both?: boolean }) {
  if (both) {
    return (
      <span className="inline-flex -space-x-1">
        <span className="size-2.5 rounded-full bg-sky-500 ring-1 ring-background" />
        <span className="size-2.5 rounded-full bg-rose-500 ring-1 ring-background" />
      </span>
    );
  }
  return <span className={cn("size-2.5 rounded-full", memberStyle(color).dot)} />;
}
